import { Currency } from '../../../../global/models';
import {
    DEFAULT_CURRENCY,
    DEFAULT_LOCALE,
} from './constants';

/*
 * The Giving Checkout helpers that used to live here -- getGiftFromState, getNextStep, getPreviousStep,
 * getOccurrenceLabel, getRecurringPattern, isGiftStartingToday and getWalletPayLabel -- went with the Stripe
 * checkout surface under AB#112440.
 *
 * `computeTotal()` was briefly relocated here from the retired recurringGiving module, but it existed only to fake a
 * realtime Commitment update after a Stripe gift (working around Stripe's search-indexing delay).  That is an
 * anachronism now that online giving runs through Tithe.ly, so the feature and the helper went too.
 */

// eslint-disable-next-line import/prefer-default-export -- kept as a named export; it has ten call sites.
export const formatNumberAsCurrency = (
    numberToFormat: number,
    currency: Currency = DEFAULT_CURRENCY,
    locale: string = DEFAULT_LOCALE,
) => (
    new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(numberToFormat)
);
